var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFuel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_252:4014)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.99123 16.3595C12.7845 16.3595 15.8595 13.2845 15.8595 9.49122C15.8595 5.69796 12.7845 2.62292 8.99123 2.62292C5.19797 2.62292 2.12292 5.69796 2.12292 9.49122C2.12292 13.2845 5.19797 16.3595 8.99123 16.3595Z",
    fill: "#785B10",
    stroke: "#FFC700",
    strokeWidth: 1.24878
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.853 10.0635C11.853 7.48784 8.99119 5.48457 8.99119 5.48457C8.99119 5.48457 6.12939 7.48784 6.12939 10.0635C6.12939 10.8224 6.43092 11.5503 6.96758 12.087C7.50427 12.6237 8.23217 12.9252 8.99119 12.9252C9.75017 12.9252 10.4781 12.6237 11.0148 12.087C11.5515 11.5503 11.853 10.8224 11.853 10.0635Z",
    stroke: "#FFC700",
    strokeWidth: 1.24878,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99109 11.3081C9.34111 11.2486 9.66405 11.0819 9.91526 10.831C10.1665 10.5801 10.3336 10.2573 10.3935 9.90738",
    stroke: "#FFC700",
    strokeWidth: 1.24878,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.49854 5.6377L2.74732 5.12047L3.26458 3.87165L3.6839 5.12047L5.03063 5.6377L3.6839 6.05706L3.26458 7.40372L2.74732 6.05706L1.49854 5.6377Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_252:4014",
    x: 1.49854,
    y: 1.99853,
    width: 14.9854,
    height: 15.1025,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.749268
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0585366
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.33 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_252:4014"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuel);
export default __webpack_public_path__ + "static/media/fuel.c5d13d35.svg";
export { ForwardRef as ReactComponent };